import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
var text = colorUseCases.text;
export default css({
  color: getColorScaleValueByUseCase("neutral", text.lowContrast),
  height: "1rem",
  width: "1rem",
  variants: {
    sortBy: {
      descending: {
        transform: "rotate(180deg)"
      },
      ascending: {
        transform: "rotate(0deg)"
      }
    }
  }
});